import { create } from 'zustand';
import {
  getCachedPermissions,
  getPermissionsStorageKey,
} from 'utils/memberPermissionsStorage';

interface MemberPermissionsStore {
  /** Storage keys → permission ids (in-memory mirror of localStorage). */
  byKey: Record<string, string[]>;
  /** Bumps when any entry changes so hooks re-subscribe. */
  version: number;
  getPermissions: (
    companyId: string | null | undefined,
    userId: string | null | undefined,
  ) => string[];
  setPermissions: (
    companyId: string,
    userId: string,
    permissions: string[],
  ) => void;
  reset: () => void;
}

export const useMemberPermissionsStore = create<MemberPermissionsStore>(
  (set, get) => ({
    byKey: {},
    version: 0,

    getPermissions(companyId, userId) {
      if (!companyId || !userId) {
        return [];
      }
      const key = getPermissionsStorageKey(companyId, userId);
      const cached = get().byKey[key];
      if (cached) {
        return cached;
      }
      const fromStorage = getCachedPermissions(companyId, userId);
      if (fromStorage.length > 0) {
        set((state) => ({
          byKey: { ...state.byKey, [key]: fromStorage },
        }));
      }
      return fromStorage;
    },

    setPermissions(companyId, userId, permissions) {
      const key = getPermissionsStorageKey(companyId, userId);
      const next = [...permissions];
      localStorage.setItem(key, JSON.stringify(next));
      set((state) => ({
        byKey: { ...state.byKey, [key]: next },
        version: state.version + 1,
      }));
    },

    reset() {
      set({ byKey: {}, version: 0 });
    },
  }),
);
